import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const LeverancierTestimonials = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Jan van der Berg",
      company: "SolarTech Nederland",
      role: "Eigenaar",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
      content: `Sinds ik bij Verduurzaamwijzer ben aangesloten, is mijn klantenbestand met 300% gegroeid. Het platform maakt het zo makkelijk om nieuwe klanten te bereiken.`,
      rating: 5,
      projectsCompleted: 150,
      specialization: "Zonnepanelen"
    },
    {
      id: 2,
      name: "Maria Jansen",
      company: "WarmtePompen Plus",
      role: "Directeur",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
      content: `De kwaliteit van de leads is uitstekend. Klanten die via het platform komen zijn goed geïnformeerd en serieus geïnteresseerd in onze diensten.`,
      rating: 5,
      projectsCompleted: 89,
      specialization: "Warmtepompen"
    },
    {
      id: 3,
      name: "Pieter Bakker",
      company: "Isolatie Experts",
      role: "Oprichter",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
      content: `Het dashboard geeft me perfect inzicht in mijn leads en projecten. De automatische matching met klanten bespaart me veel tijd.`,
      rating: 5,
      projectsCompleted: 203,
      specialization: "Isolatie"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials?.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials?.length]);

  const currentData = testimonials?.[currentTestimonial];

  return (
    <div className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-lg border border-border shadow-elevation-1 p-6">
      <div className="text-center mb-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
          Succesverhalen van Leveranciers
        </h3>
        <p className="text-sm font-body text-muted-foreground">
          Ontdek hoe andere leveranciers succesvol zijn geworden
        </p>
      </div>
      <div className="relative">
        <div className="bg-card rounded-lg p-6 shadow-elevation-1">
          {/* Leverancier Info */}
          <div className="flex items-center space-x-4 mb-4">
            <div className="relative">
              <Image
                src={currentData?.avatar}
                alt={currentData?.name}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-success rounded-full flex items-center justify-center">
                <Icon name="CheckCircle" size={12} color="white" />
              </div>
            </div>
            <div className="flex-1">
              <h4 className="text-sm font-heading font-semibold text-foreground">
                {currentData?.name}
              </h4>
              <p className="text-xs font-body text-muted-foreground">
                {currentData?.role} bij {currentData?.company}
              </p>
              <div className="flex items-center space-x-1 mt-1">
                {[...Array(currentData?.rating)]?.map((_, i) => (
                  <Icon key={i} name="Star" size={12} color="var(--color-accent)" />
                ))}
              </div>
            </div>
          </div>

          {/* Testimonial Content */}
          <blockquote className="text-sm font-body text-foreground mb-4 italic">
            "{currentData?.content}"
          </blockquote>

          {/* Stats */}
          <div className="flex items-center justify-between pt-4 border-t border-border">
            <div className="text-center">
              <div className="text-lg font-heading font-semibold text-primary">
                {currentData?.projectsCompleted}
              </div>
              <div className="text-xs font-caption text-muted-foreground">
                Projecten
              </div>
            </div>
            <div className="text-center">
              <div className="text-sm font-body text-foreground">
                {currentData?.specialization}
              </div>
              <div className="text-xs font-caption text-muted-foreground">
                Specialisatie
              </div>
            </div>
          </div>
        </div>

        {/* Navigation Dots */}
        <div className="flex justify-center space-x-2 mt-4">
          {testimonials?.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentTestimonial(index)}
              className={`w-2 h-2 rounded-full transition-micro ${
                index === currentTestimonial ? 'bg-primary' : 'bg-muted'
              }`}
              aria-label={`Ga naar testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
      {/* Platform Benefits */}
      <div className="mt-6 pt-6 border-t border-border">
        <h4 className="text-sm font-heading font-medium text-foreground mb-3 text-center">
          Waarom kiezen leveranciers voor ons?
        </h4>
        <div className="grid grid-cols-2 gap-3">
          <div className="text-center">
            <Icon name="TrendingUp" size={20} color="var(--color-success)" className="mx-auto mb-1" />
            <p className="text-xs font-caption text-muted-foreground">Meer Leads</p>
          </div>
          <div className="text-center">
            <Icon name="Clock" size={20} color="var(--color-success)" className="mx-auto mb-1" />
            <p className="text-xs font-caption text-muted-foreground">Tijd Besparing</p>
          </div>
          <div className="text-center">
            <Icon name="Target" size={20} color="var(--color-success)" className="mx-auto mb-1" />
            <p className="text-xs font-caption text-muted-foreground">Kwaliteit Klanten</p>
          </div>
          <div className="text-center">
            <Icon name="BarChart" size={20} color="var(--color-success)" className="mx-auto mb-1" />
            <p className="text-xs font-caption text-muted-foreground">Groei Inzicht</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeverancierTestimonials;